<template>
  <div>
    <header-info cur="8"></header-info>
    <div
      id="center"
      class="hidebox"
    >
      <div
        class="list-question"
        v-if="finishedSurveyIds.indexOf(survey_id) < 0"
      >
        <h2>{{ surveyInfo ? surveyInfo.title : '' }}</h2>
        <hr>
        <ul>
          <li
            v-for="(question, index) in questions"
            :key="index"
          >
            <div>
              <span class="question-title">{{ index + 1 }}.</span>
              <span
                class="question-title"
                v-html="question.content"
              ></span>
            </div>
            <div>
              <ul class="question-list">
                <li
                  v-for="(option, op_index) in question.options"
                  :key="op_index"
                >
                  <input
                    type="radio"
                    v-if="question.questionType == 1"
                    :name="'' + question.id + '_' + option.id"
                    @click="surveyRadClick(question, option)"
                    :checked="question.selectOption.indexOf(option.code) >= 0"
                  >
                  <input
                    type="checkbox"
                    v-if="question.questionType == 2"
                    :name="'' + question.id + '_' + option.id"
                    @click="surveyCkClick(question, option)"
                    :checked="question.selectOption.indexOf(option.code) >= 0"
                  >
                  {{ option.code }}. {{ option.title }}
                </li>
              </ul>
            </div>
          </li>
        </ul>

      </div>
      <div
        class="footer-btn"
        v-if="!survey_id"
      >
        暂时没有数据
      </div>
      <div
        class="footer-btn"
        v-if="finishedSurveyIds.indexOf(survey_id) < 0"
      >
        <div
          class="add-btn"
          v-if="survey_id"
          @click="saveStudentSurvey"
        >提交</div>
      </div>
      <div
        class="footer-btn"
        v-if="finishedSurveyIds.indexOf(survey_id) >= 0"
      >
        调查问卷已提交！
      </div>
    </div>

    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
export default {
  name: 'Survey',
  components: {
    HeaderInfo,
    FooterInfo
  },
  data() {
    return {
      // 调查问卷
      survey_id: null,
      surveyInfo: null,
      allQuestion: [],
      allOption: [],
      questions: [],
      finishedSurveyIds: []
    }
  },
  computed: {

  },
  methods: {
    // 调查问卷
    async getSurveyInfo () {
      this.survey_id = null
      this.surveyInfo = null
      this.finishedSurveyIds = []

      await this.$http.get('/web_survey/', {
        params: {
          status: 1
        }
      }).then((data) => {
        if (data.results.length > 0) {
          this.surveyInfo = data.results[0]
          this.survey_id = data.results[0].id
        }
      })

      await this.$http.get('/web_user_survey/', {
        params: {
          webSurvey_id: this.survey_id,
          userprofile_id: this.$store.state.userInfo.profile_id
        }
      }).then((data) => {
        if (data.results.length > 0) {
          for (let i = 0; i < data.results.length; i++) {
            this.finishedSurveyIds.push(data.results[i].webSurvey_id)
          }
        }
      })

      if (this.survey_id && this.finishedSurveyIds.indexOf(this.survey_id) < 0) {
        await this.$http.get('/web_survey_question/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.survey_id
          }
        }).then((data) => {
          this.allQuestion = data.results
        })

        await this.$http.get('/web_survey_question_option/', {
          params: {
            page: 1,
            size: 10000,
            survey_id: this.survey_id
          }
        }).then((data) => {
          this.allOption = data.results
        })

        const data = []
        for (let i = 0; i < this.allQuestion.length; i++) {
          const question = this.allQuestion[i]
          question.options = []
          this.$set(question, 'selectOption', [])
          for (let j = 0; j < this.allOption.length; j++) {
            if (this.allOption[j].surveyQuestion_id === question.id) {
              question.options.push(this.allOption[j])
            }
          }
          data.push(question)
        }
        this.questions = data
      }
    },
    surveyRadClick(question, option) {
      question.selectOption = []
      question.selectOption.push(option.code)
    },
    surveyCkClick(question, option) {
      if (question.selectOption.indexOf(option.code) >= 0) {
        question.selectOption.splice(question.selectOption.indexOf(option.code), 1)
      } else {
        question.selectOption.push(option.code)
      }
      question.selectOption.sort()
    },
    async saveStudentSurvey () {
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].selectOption.length === 0) {
          this.$layer.msg('请选择全部题目后再提交！')
          return false
        }
      }
      const data = {
        userprofile_id: this.$store.state.userInfo.profile_id,
        webSurvey_id: this.survey_id,
        questions: []
      }
      for (let i = 0; i < this.questions.length; i++) {
        data.questions.push({
          surveyQuestion_id: this.questions[i].id,
          selectOption: this.questions[i].selectOption
        })
      }
      await this.$http.post('/web_user_survey_save/', {
        json_data: JSON.stringify(data)
      }).then((data) => {
        if (data.code === '200') {
          this.$layer.msg('提交成功！')
          this.getSurveyInfo()
        } else {
          this.$layer.msg('提交失败！')
        }
      })
    }
  },
  created() {
    this.getSurveyInfo()
  }
}
</script>
<style lang="less" scoped>
.list-question {
  width: 1200px;
  margin: 30px auto 0;
  h2 {
    text-align: center;
  }
  .question-title {
    font-size: 18px;
    display: inline-block;
  }
  .question-del {
    border: 1px solid indianred;
    border-radius: 3px;
    padding: 2px 4px;
    color: indianred;
    float: right;
  }
  .question-list {
    margin: 10px 10px 30px 10px;
  }
  .question-list > li {
    font-size: 16px;
    margin: 4px;
    input {
      margin-right: 5px;
    }
  }
}
.footer-btn {
  text-align: center;
  font-size: 18px;
  margin-top: 30px;
  .add-btn {
    padding-left: 15px;
    padding-right: 15px;
  }
}
.no-info {
  font-size: 18px;
  text-align: center;
}
</style>
